import React, {useState, useEffect} from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { IOID4VCIClientCreateOfferUriResponse } from "@sphereon/ssi-sdk.oid4vci-issuer-rest-client";
import { QRRenderingProps, QRType } from "@sphereon/ssi-sdk.qr-code-generator";
import { IssueStatus, IssueStatusResponse } from "@sphereon/oid4vci-common";
import agent from "../../../../../agent";
const short = require("short-uuid");

interface DigitalRoomKeyProps{
  fullName: string;
}


const DigitalRoomKey = (props: DigitalRoomKeyProps) => {
  const [showBookingDetails, setShowBookingDetails] = useState(false);
  const [showBookingForm, setShowBookingForm] = useState(false);
  const [bookingIssued, setBookingIssued] = useState(false);
  const [bookingId, setBookingId] = useState("");
  const [lastName, setLastName] = useState("");
  const [qrData, setQrData] = useState<any>();
  const [uri, setUri] = useState("");
  const [preAuthCode, setPreAuthCode] = useState("");
  const [qrCode, setQrCode] = useState<JSX.Element>();

  useEffect(() => {
    generateNewQRCodeForInsurance();
  }, []);

  const renderingProps: QRRenderingProps = {
    bgColor: "#FBFBFB",
    fgColor: "black",
    level: "L",
    size: 330,
  };

  const handleButtonClick = () => {
    setShowBookingForm(true);
  };

  const handleFormSubmit = () => {
    setShowBookingForm(false);
    setShowBookingDetails(true);
  };

  const generateNewQRCodeForInsurance = async () => {
    const shortUuid = short.generate();
    let today = new Date();
  }
  return (
    <Container style={{ textAlign: "center", padding: "50px" }}>
      {bookingIssued == false? (
              <Row className="my-5" style={{ height: "100%" }}>
              <Col md={6} className="d-flex align-items-center">
                <div>
                  <h2>The pre-check-in process has been successfully completed.</h2>
                </div>
              </Col>
              <Col
                md={6}
                className="text-center d-flex flex-column justify-content-center align-items-center"
              >
                <div>
                  {/* <div>{qrCode}</div> */}
                </div>
              </Col>
            </Row>
            ) : (
              <Row className="my-5" style={{ height: "100%" }}>
              <Col md={12} className="align-items-center">
                <div>
                  <h2>Enjoy your stay and we hope you will have a great experience!</h2>
                </div>
              </Col>
            </Row>
            )}
    </Container>
  );
};

export default DigitalRoomKey;
